import { Component, OnInit } from '@angular/core';

import { Form, FormMode } from '../../../base/form';
import { FormGroup, Validators } from '@angular/forms';
import { ContractService } from '../../../services/contract.service';
import { blank, filled } from '../../../shared/utils/common';
import { cloneDeep, get } from 'lodash-es';
import { NotificationService } from '../../../services/notification.service';
import { LooseObject } from '../../../objects/loose-object';
import { RecordService } from '../../../services/record.service';
import { FormService } from '../../../services/form.service';
import { Relate } from '../../../objects/relate';
import { filter, first, switchMap, tap } from 'rxjs/operators';
import { MatDialog } from '@angular/material';
import { ViewService } from '../../../services/view.service';
import { ListingService } from '../../../services/listing.service';
import CommonPaginationConfig from '../../../shared/components/listing/common/pagination/common-pagination.component';
import { EditRecurringInvoiceFormComponent } from '../../../shared/components/widget/recurring_invoices/form/edit-recurring_invoice-form.component';
import moment from 'moment';
import { RecurringJobsService } from '../../../services/recurring-jobs.service';

@Component({
  selector: 'app-contract-recurring-invoices',
  templateUrl: './contract-recurring-invoices.component.html',
  styleUrls: ['./contract-recurring-invoices.component.scss'],
  providers: [
    RecurringJobsService
  ]
})
export class ContractRecurringInvoicesComponent implements OnInit {

  strMode: string = 'view';

  strModule: string = '';

  strModuleId: string = '';

  objMetadata: LooseObject = {};

  objParentForm: FormGroup;

  objRecurringInvoice: LooseObject = {};

  bShowForm: boolean = false;

  arFrequencyList = [
    {
      id: 'day',
      text: 'day'
    },
    {
      id: 'week',
      text: 'week'
    },
    {
      id: 'day',
      text: 'day'
    },
    {
      id: 'month',
      text: 'month'
    },
    {
      id: 'year',
      text: 'year'
    },
  ];

  arRecurringInvoiceRecord: LooseObject[] = [];

  objPagination: CommonPaginationConfig;

  arSiteList: LooseObject[] = [];

  bShowRelatedRecurringInvoice: boolean = false;

  objRecurringInvoiceConfig: LooseObject = {};

  bLoading: boolean = true;

  get customerId(): string {
    let strCustomerId = get(this.viewService.arRecord, 'customer_id');
    return filled(strCustomerId) ? strCustomerId : '';
  }

  get isForm(): boolean {
    return this.strMode == 'edit' || this.strMode == 'add';
  }

  get isEdit(): boolean {
    return this.strMode == 'edit';
  }

  get displayList(): boolean {
    return this.strMode == 'edit' || this.strMode == 'view';
  }

  constructor(
    public listingService: ListingService,
    private notificationService: NotificationService,
    private recordService: RecordService,
    private matDialog: MatDialog,
    private viewService: ViewService,
    private contractService: ContractService,
    private recurringJobsService: RecurringJobsService,
    private formService: FormService,
  ) {

  }

  ngOnInit() {
    if (this.displayList) {
      this._setUpRecurringInvoiceListing();
      this.getExistingRecurringInvoices();
    } else {
      this.bLoading = false;
    }
  }

  /**
   * @inheritdoc
   */
  setFormMode(mode: FormMode): void {
    this.strMode = mode;
  }

  /**
   * @inheritdoc
   */
  setParentForm(parentForm: FormGroup): void {
    this.objParentForm = parentForm;
  }

  /**
   * @inheritdoc
   */
  setField(field: Form<any>): void {
  }

  onIntervalChange(recurringInvoice: LooseObject) {
    let strQuantity = get(recurringInvoice, 'repeated_every_quantity');
    let strFrequency = get(recurringInvoice, 'repeated_every_frequency');

    recurringInvoice.repeated_every = (filled(strQuantity) && filled(strFrequency))
      ? `${strQuantity}_${strFrequency}`
      : null;

    this.updateParentForm();
  }

  getExistingRecurringInvoices(): void {
    this.bLoading = true;
    this.contractService.getRecurringInvoiceGroupBySite(null, this.strModuleId).subscribe( response => {
      this.arSiteList = get(response, 'body');
      this.bLoading = false;
    });
  }

  editRecurringInvoice(recurringInvoice: LooseObject): void {
    let strRecurringInvoiceId = get(recurringInvoice, 'id');
    if (filled(strRecurringInvoiceId)) {

      this.matDialog.open(EditRecurringInvoiceFormComponent, {
        maxWidth: '100%',
        width: '80%',
        height: 'auto',
        disableClose: true,
        data: {
          isNew: false,
          moduleID: strRecurringInvoiceId,
          moduleName: this.strModule,
          recordID: strRecurringInvoiceId,
        },
      })
      .afterClosed()
      .pipe(
        first(),
        filter(response => filled(response) && response !== false),
        tap(() => this.getExistingRecurringInvoices()),
        tap(() => this.notificationService.notifySuccess('header_notification.success_update')),
      )
      .subscribe();
    }
  }

  updateLineItemData(event): void {
    this.objRecurringInvoice = {
      ...this.objRecurringInvoice,
      ...event,
    };
    this.updateParentForm();
  }

  updateParentForm(): void {
    let objRecurringInvoice = cloneDeep(this.objRecurringInvoice);
    let objInvoiceData = {
      repeated_every: objRecurringInvoice.repeated_every,
      next_invoice_date: filled(objRecurringInvoice.next_invoice_date)
        ? objRecurringInvoice.next_invoice_date.format('YYYY-MM-DD')
        : null,
      invoice_date: get(objRecurringInvoice, 'invoice_date.id', 'today'),
      payment_terms_id: get(objRecurringInvoice, 'payment_terms_id.value.id', null),
      line_items: get(objRecurringInvoice, 'line_items'),
      amount_tax: get(objRecurringInvoice, 'amount_tax'),
      amount_tax_ex: get(objRecurringInvoice, 'amount_tax_ex'),
      amount_tax_inc: get(objRecurringInvoice, 'amount_tax_inc'),
      tax_adjustment_amount: get(objRecurringInvoice, 'tax_adjustment_amount'),
      next_job_date: moment().startOf('day').add(1, 'year').format('YYYY-MM-DD'),
    };

    if (!this._hasValidData()) {
      objInvoiceData = null;
    }

    this.objParentForm.controls.contract_recurring_invoices.setValue(objInvoiceData);
  }

  createForm(): void {
    if (this.isForm) {
      this.recordService.getRecordConfig('recurring_invoices', null, true).subscribe( response => {
        this.objRecurringInvoiceConfig = cloneDeep(response);
        this.objMetadata = {
          ...response['used_fields'],
          ...response['available_fields']
        };
        this.objMetadata.invoice_date.default_value = {
          id: 'today',
          text: 'today',
        };

        this.objRecurringInvoice = {
          repeated_every: null,
          repeated_every_quantity: null,
          repeated_every_frequency: null,
          next_invoice_date: moment(moment.utc().toDate()).local(),
          invoice_date: {
            id: 'today',
            text: 'today',
          },
          payment_terms_id: new Relate<any>().buildRelates(
            switchMap(strTerm => this.recordService.getRecordRelate('payment_terms', strTerm, false, false, { is_customer: true }))
          ),
          user_id: new Relate<any>().buildRelates(
            switchMap(strTerm => this.recordService.getRecordRelate('users', strTerm, false, false))
          ),
          line_items: []
        };

        this.objParentForm.controls.contract_recurring_invoices.setValidators([Validators.required]);
        this.objParentForm.controls.contract_recurring_invoices.updateValueAndValidity();

        this.bShowForm = true;
      });
    } else {
      this.matDialog.open(EditRecurringInvoiceFormComponent, {
        maxWidth: '100%',
        width: '100%',
        height: 'auto',
        disableClose: true,
        data: {
          isNew: true,
          moduleName: this.strModule,
          contract_id: get(this.viewService.getViewRecord(), 'id'),
          contract_text: get(this.viewService.getViewRecord(), 'contract_number'),
          customer_id: get(this.viewService.getViewRecord(), 'customer_id'),
          customer_text: get(this.viewService.getViewRecord(), 'customer_text'),
          invoice_date_id: 'today',
          invoice_date_text: 'today',
          next_invoice_date: moment(moment.utc().toDate()).local(),
        },
      })
      .afterClosed()
      .subscribe((response) => {
        if (get(response, 'message') === 'save') {
          this.getExistingRecurringInvoices();
        }
      });
    }
  }

  deleteForm(): void {
    this.bShowForm = false;
    this.objRecurringInvoice = {};
    this.objParentForm.controls.contract_recurring_invoices.setValue(null);
    this.objParentForm.controls.contract_recurring_invoices.clearValidators();
    this.objParentForm.controls.contract_recurring_invoices.updateValueAndValidity();
  }

  /**
   * format repeated at to readable
   *
   * @param data
   * @returns
   */
  formatRepeated(data: string) {
    return this.recurringJobsService.formatRepeatedEvery(data);
  }

  /**
   * delete record
   *
   * @param recurringInvoice
   * @param siteIndex
   * @param assetTypeIndex
   */
  deleteRecord(recurringInvoice: LooseObject, siteIndex: number): void {
    let strRecordId = get(recurringInvoice, 'id');
    let intIndex = this.arSiteList[siteIndex]['recurring_invoices'].findIndex( data => data.id == strRecordId);
    if (filled(strRecordId) && intIndex > -1) {
      this.notificationService.sendConfirmation('confirm_delete').pipe(
        filter((confirmation) => confirmation.answer == true ),
      ).subscribe( () => this.recordService.deleteRecord('recurring_invoices', strRecordId)
        .pipe(
          first(),
        )
        .subscribe( response => {
          if (get(response, 'status') == 200) {
            this.notificationService.notifySuccess('record_delete_success');
            this.arSiteList[siteIndex]['recurring_invoices'].splice(intIndex, 1);
          } else {
            let hasObjectResponse = (typeof response.body === 'object' && response.body['message']);
            this.notificationService.sendNotification(
              'warning',
              hasObjectResponse ? response.body['message'] : response.body.toString(),
              'warning'
            );
          }
        }, error => {
          if (error.error.id) {
            this.notificationService.sendNotification('not_allowed', error.error.id[0], 'warning');
          }
        })
      );
    }
  }

  private _setUpRecurringInvoiceListing(): void {
    const objRecord = this.recordService.getParentData();

    this.strModule = objRecord.module;
    this.strModuleId = objRecord.id;

    if (blank(this.strModuleId)) {
      const objForm = this.formService.getRecord('contracts');
      this.strModuleId = get(objForm, 'record_details.id');
    }
  }

  private _hasValidData(): boolean {
    return filled(get(this.objRecurringInvoice, 'repeated_every'))
      && filled(get(this.objRecurringInvoice, 'next_invoice_date'))
      && filled(get(this.objRecurringInvoice, 'invoice_date'))
      && filled(get(this.objRecurringInvoice, 'payment_terms_id'))
      && get(this.objRecurringInvoice, 'has_valid_line_items') == true;
  }
}
